import Question from '../Question';
import { useEffect } from 'react';
import Questions from '../../../lib/Questions';

const EditFormSubmission = ({
  currentQuestionsAndAnswers,
  newAnswers,
  setNewAnswers,
}) => {
  useEffect(() => {
    // Initial answers...
    const answers = {};
    for (const a of currentQuestionsAndAnswers) {
      let answerData = a.answer.answer;
      try {
        answerData = JSON.parse(answerData);
      } catch (e) {
        // ...
      }
      answers[a.question.id] = answerData;
    }
    console.log(`@{EditFormSubmission} initial answers`, answers);
    setNewAnswers(answers);
  }, []);

  return (
    <div className="mt-2">
      {currentQuestionsAndAnswers.map((data, idx) => (
        <div key={data.question.id}>
          {!Questions[data.question.type]
            ?.excludeFromAnswers /*handle separately*/ && (
            <div className={idx > 0 ? 'mt-4' : ''}>
              <Question
                isReadOnly={false}
                question={data.question}
                value={newAnswers[data.question.id]}
                setValue={value => {
                  console.log('setting question', data.question, '=', value);
                  setNewAnswers(old => {
                    if (typeof value === 'function') {
                      value = value(old[data.question.id]);
                    }
                    console.log(`@{EditFormSubmission} other answers`, {
                      ...old,
                      [data.question.id]: value,
                    });
                    return {
                      ...old,
                      [data.question.id]: value,
                    };
                  });
                }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default EditFormSubmission;
